import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { CommandModalButton } from '../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../commandActions/types'
import { UpdateCommunicationPreferenceForm } from './UpdateCommunicationPreferenceForm'

/**
 * Update communication preference command is when a person's preferred channel of communications is set. When the command is applied, further communication with that person will follow the selected channel.
 *
 * @links
 * - [LegalEntity commands](@root/legalentity/legalentity-server/doc/solution/commands/LegalEntityCommands.md)
 * - @api legalentity-shared/UpdateCommunicationPreferenceCommandData, APIs for Update communication preference@
 */
export function UpdateCommunicationPreferenceCommand(props: ActionButtonProps) {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()

  const actions = useHook(
    'mutators.crm.useChangeCommunicationPreferencesActions',
  )({
    tenantId,
    personId: ownerId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="legalEntity.UpdateCommunicationPreferenceCommandData"
      title={translate('updateCommunicationPreference.title')}
      {...props}
      commandDataForm={UpdateCommunicationPreferenceForm}
      submit={submit}
    />
  )
}
